import React from 'react';
import EditCustomerState from './editCustomerState/EditCustomerState';
import { CustomerForms } from './components/CustomerForms';
import { ModalWindows } from './components/ModalWindows';

export const EditCustomerPageNewUi: React.FC = () => (
	<EditCustomerState>
		<CustomerForms />
		<ModalWindows />
	</EditCustomerState>
);
